const NewsMediaIndex = () => import('./views/NewsMediaIndex.vue')
const NewsMediaCreate = () => import('./views/NewsMediaCreate.vue')
const NewsMediaEdit = () => import('./views/NewsMediaEdit.vue')

export default [
  {
    path: 'media',
    name: 'news.media.index',
    component: NewsMediaIndex
  },
  {
    path: 'media/create',
    name: 'news.media.create',
    component: NewsMediaCreate
  },
  {
    path: 'media/:mediaId(\\d+)',
    name: 'news.media.edit',
    component: NewsMediaEdit
  }
]
